module.exports = __webpack_public_path__ + "static/media/individual-enrolment-img.58f87c04.png";